// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
/**
 * Typed client for the Granite REST API. Types come from api/openapi.yaml via
 * openapi-typescript (src/schema.gen.ts, regenerated with `make gen`).
 */
import createClient, {} from "openapi-fetch";
/** Creates an API client that attaches the bearer token to every request. */
export function createGraniteClient(options) {
    const client = createClient({
        baseUrl: options.baseUrl.replace(/\/+$/, ""),
        ...(options.fetch ? { fetch: options.fetch } : {}),
        ...(options.headers ? { headers: options.headers } : {}),
        ...(options.credentials ? { credentials: options.credentials } : {}),
    });
    const { getAccessToken } = options;
    if (getAccessToken) {
        const auth = {
            async onRequest({ request }) {
                const token = await getAccessToken();
                if (token)
                    request.headers.set("Authorization", `Bearer ${token}`);
                return request;
            },
        };
        client.use(auth);
    }
    return client;
}
/** Error carrying an RFC 9457 problem document returned by the API. */
export class ApiError extends Error {
    problem;
    constructor(problem) {
        super(problem.detail ?? problem.title);
        this.name = "ApiError";
        this.problem = problem;
    }
    get status() {
        return this.problem.status;
    }
    /** Stable slug from the problem `type`, for example `conflict`. */
    get kind() {
        return this.problem.type.split("/").pop() ?? "";
    }
}
/** Returns true when value has the shape of a problem document. */
export function isProblem(value) {
    if (typeof value !== "object" || value === null)
        return false;
    const v = value;
    return typeof v.type === "string" && typeof v.title === "string" && typeof v.status === "number";
}
/**
 * Unwraps an openapi-fetch result: returns data, or throws ApiError for problem
 * responses (and a plain Error for anything else).
 */
export function unwrap(result) {
    if (result.error !== undefined) {
        if (isProblem(result.error))
            throw new ApiError(result.error);
        throw new Error(`Granite API request failed with status ${result.response.status}`);
    }
    return result.data;
}
//# sourceMappingURL=index.js.map